import { EndOfDayManifestSchema } from "@redotech/redo-fulfillment-group-common/scan-form";
import { PaginationCursorSchema } from "@redotech/redo-views-common/table";
import * as z from "zod";

export const getEndOfDayManifests = {
  name: "getEndOfDayManifests" as const,
  input: z.object({
    pageSize: z.number(),
    pageNumber: z.number(),
    paginationCursor: PaginationCursorSchema.nullish(),
  }),
  output: z.object({
    endOfDayManifests: z.array(EndOfDayManifestSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
  }),
};
